import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import "./../../assets/css/Dashboard/PharmacyDetails.scss";
import { BsThreeDots } from "react-icons/bs";
import ServicesSection from "./../../pages/Dashboard/ServicesTab/ServicesTab";
import OverviewTab from "./../../pages/Dashboard/OverviewTab/OverviewTab";
import PatientDashboardPage from "./pages/PatientDashboardPage";
import TeamMembers from "../Header/TeamMembers";
import { LiaSearchSolid, LiaFilePrescriptionSolid } from "react-icons/lia";
import PatientTab from "../../pages/Dashboard/PatientListView/PatientTab";
import PatientSearch from "../PatientSearch/PatientSearch";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Map, Marker, NavigationControl } from "react-map-gl";
import useTitanApp from "../../hooks/useTitanApp";
import { FaRegUser } from "react-icons/fa";
import { LiaHistorySolid } from "react-icons/lia";
import { CiBoxList } from "react-icons/ci";
import { SlGraph } from "react-icons/sl";
import { FaApple } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import {
  setIsPatientDashboard,
  setCurrentShowPatientDetailsEditModal,
} from "../../dispatchers/patientDispatchers";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import CustomButton from "../controls/CustomButton";
import PatientDetailsEditModal from "./components/PatientDetailsEditModal";
import { TbActivityHeartbeat } from "react-icons/tb";
import AddPatientPopUp from "../GlobalHeader/components/AddPatientPopUp";

const PatientDashboard = ({ handlePatientIconClick }) => {
  // const [value, setValue] = React.useState(1);
  const { appState, patientState } = useTitanApp();
  const { darkMode, features } = appState || {};
  const { showPatientDetailsEditModal, selectedPatientDetails } =
    patientState || {};
  const [isSearchIconClicked, setSearchIconClicked] = useState(false);
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const consultationOptions = [
    { label: "Travel Vaccine", value: "Travel Vaccine" },
    { label: "Ear Wax", value: "Ear Wax" },
    { label: "Blood Pressure Check", value: "Blood Pressure" },
    { label: "Medication Review", value: "Medication Review" },
    { label: "Health Screening", value: "Health Screening" },
  ];
  const location = useLocation();
  const navigateFromDashboard =
    location.state && location?.state?.moveFromDashboard;
  const selectedPatientName =
    location.state && location?.state?.selectedPatientName;
  const selectedPatientAddress =
    location.state && location?.state?.selectedPatientAddress;
  const pharmacyAvgVal = location.state && location?.state?.pharmacyAvgVal;
  const { pharmacyId } = useParams() || {
    pharmacyId: "00000000-0000-0000-0000-000000000000",
  };
  const {
    ifMapEnabled,
    ifPatientDashboardEnabled,
    ifPatientListEnabled,
    ifPatientSearchEnabled,
  } = features || {};
  const [value, setValue] = React.useState(ifMapEnabled === true ? 1 : 0);

  const patientDashboardTab = localStorage.getItem("patientDashboardTab");

  const [activeTab, setActiveTab] = React.useState(
    patientDashboardTab === null
      ? "patient-overview-wrapper"
      : patientDashboardTab,
  );

  const searchParams = new URLSearchParams(location.search);
  const pharmacyIDparam = searchParams.get("pharmacyID");

  const navigate = useNavigate();

  const handleSearchIconClick = () => {
    setSearchIconClicked(true);
  };
  const handleCrossIconClick = () => {
    setSearchIconClicked(false); // Set the state to false when the cross icon is clicked
  };
  const handleConsultationChange = (e) => {
    setSelectedConsultation(e.value); // Set the selected consultation
    setShowDialog(true); // Show confirmation dialog
  };

  const confirmConsultation = () => {
    navigate("/serviceConsultation");
  };

  const cancelConsultation = () => {
    setSelectedConsultation(null);
    setShowDialog(false);
  };

  const homeIcon = (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.01742 0.570677L13.5174 5.6476C13.825 5.93156 14 6.33116 14 6.7498V14.312C14 14.8643 13.5523 15.312 13 15.312H9.5C8.94772 15.312 8.5 14.8643 8.5 14.312V9.81197H5.5V14.312C5.5 14.8643 5.05228 15.312 4.5 15.312H1C0.447715 15.312 0 14.8643 0 14.312V6.7498C0 6.33116 0.174957 5.93156 0.48258 5.6476L5.98258 0.570677C6.55717 0.0402838 7.44283 0.0402838 8.01742 0.570677ZM7.33914 1.30548C7.14761 1.12868 6.85239 1.12868 6.66086 1.30548L1.16086 6.3824C1.05832 6.47706 1 6.61026 1 6.7498V14.312H4.5V9.81197C4.5 9.25969 4.94772 8.81197 5.5 8.81197H8.5C9.05228 8.81197 9.5 9.25969 9.5 9.81197V14.312H13V6.7498C13 6.61026 12.9417 6.47706 12.8391 6.3824L7.33914 1.30548Z"
        className="icons-color"
      />
    </svg>
  );

  const overviewIcon = (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6401 6.96504C13.3921 6.96504 14.0017 7.57464 14.0017 8.32661V13.3838C14.0017 14.1358 13.3921 14.7454 12.6401 14.7454H9.13898C8.38701 14.7454 7.77742 14.1358 7.77742 13.3838V8.32661C7.77742 7.57464 8.38701 6.96504 9.13898 6.96504H12.6401ZM4.87394 10.0869C5.62591 10.0869 6.2355 10.6964 6.2355 11.4484V13.3838C6.2355 14.1358 5.62591 14.7454 4.87394 14.7454H1.36156C0.609593 14.7454 0 14.1358 0 13.3838V11.4484C0 10.6964 0.609593 10.0869 1.36156 10.0869H4.87394ZM12.6401 8.1321H9.13898C9.03156 8.1321 8.94447 8.21918 8.94447 8.32661V13.3838C8.94447 13.4913 9.03156 13.5784 9.13898 13.5784H12.6401C12.7476 13.5784 12.8347 13.4913 12.8347 13.3838V8.32661C12.8347 8.21918 12.7476 8.1321 12.6401 8.1321ZM4.87394 11.2539H1.36156C1.25414 11.2539 1.16705 11.341 1.16705 11.4484V13.3838C1.16705 13.4913 1.25414 13.5784 1.36156 13.5784H4.87394C4.98136 13.5784 5.06845 13.4913 5.06845 13.3838V11.4484C5.06845 11.341 4.98136 11.2539 4.87394 11.2539ZM4.86273 0.739441C5.6147 0.739441 6.22429 1.34903 6.22429 2.101V7.15824C6.22429 7.87261 5.67413 8.45849 4.9744 8.51529L4.86273 8.51981H1.36156C0.609593 8.51981 0 7.91021 0 7.15824V2.101C0 1.34903 0.609593 0.739441 1.36156 0.739441H4.86273ZM4.86273 1.9065H1.36156C1.25414 1.9065 1.16705 1.99358 1.16705 2.101V7.15824C1.16705 7.26567 1.25414 7.35275 1.36156 7.35275H4.86273L4.90733 7.34761C4.99326 7.32746 5.05724 7.25032 5.05724 7.15824V2.101C5.05724 1.99358 4.97015 1.9065 4.86273 1.9065ZM12.6401 0.739441C13.3921 0.739441 14.0017 1.34903 14.0017 2.101V4.0461C14.0017 4.79807 13.3921 5.40766 12.6401 5.40766H9.13898C8.38701 5.40766 7.77742 4.79807 7.77742 4.0461V2.101C7.77742 1.34903 8.38701 0.739441 9.13898 0.739441H12.6401ZM9.13898 1.9065C9.03156 1.9065 8.94447 1.99358 8.94447 2.101V4.0461C8.94447 4.15352 9.03156 4.24061 9.13898 4.24061H12.6401C12.7476 4.24061 12.8347 4.15352 12.8347 4.0461V2.101C12.8347 1.99358 12.7476 1.9065 12.6401 1.9065H9.13898Z"
        className="icons-color"
      />
    </svg>
  );

  // const handleChange = (event, newValue) => {
  //   if (value !== newValue) {
  //     setValue(newValue);
  //   }
  // };

  const handleTabClick = (event, newValue) => {
    localStorage.setItem("patientDashboardTab", newValue);
    setActiveTab(newValue); // or dispatch, if using Redux
    const section = document.getElementById(newValue);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const closePatientModal = () => {
    navigate(`/`);
    setIsPatientDashboard(false);
  };

  useEffect(() => {
    document.body.className = `${darkMode ? "dark-theme" : "light-theme"}`;
  }, []);

  const [viewport, setViewport] = useState({
    latitude: 54.7023545,
    longitude: -3.2765753,
    zoom: 16,
  });

  const [getServicesCount, setGetServicesCount] = useState(0);

  const handleGetServicesCount = (count) => {
    setGetServicesCount(count);
  };

  const theme = {
    color: `${darkMode === false ? "#000" : "#fff"}`,
  };

  const CountTheme = {
    color: `${darkMode === false ? "#black" : "white"}`,
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <div className="pharmacy_header_modal">
        <div
          className="pharmacy_header_modal patient-details-modal"
          id="patient-dboard-wrapper"
        >
          <div className="modal-content map-blur">
            {/* <div className="tabs_box top-tabs"> */}
            {/* <Tabs
                value={activeTab}
                onChange={handleTabClick}
                aria-label="Tabs"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#000",
                  },
                  tabbartabstyle: {
                    width: "auto",
                    padding: 0,
                    marginRight: 32,
                  },
                }}
              >
                <Tab
                  icon={homeIcon}
                  onClick={closePatientModal}
                  className="homeIcon"
                />
                <Tab
                  style={theme}
                  icon={overviewIcon}
                  iconPosition="start"
                  onClick={() => scrollToSection("patient-dboard-wrapper")}
                  label={
                    <span
                      className={`tabs_text`}
                      // className={`tabs_text ${value === 1 ? "active_tab" : ""}`}
                    >
                      Overview
                    </span>
                  }
                  value="patient-overview-wrapper"
                />

                <Tab
                  icon={<FaRegUser className="icons-color" />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>Patient Details</span>}
                  onClick={() => scrollToSection("patient-details-wrapper")}
                  value="patient-details-wrapper"
                />
                <Tab
                  icon={<CiBoxList className="icons-color" size={20} />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>Appointments</span>}
                  onClick={() =>
                    scrollToSection("patient-appointments-wrapper")
                  }
                  value="patient-appointments-wrapper"
                />
                <Tab
                  icon={<LiaHistorySolid className="icons-color" size={20} />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>History</span>}
                  onClick={() =>
                    scrollToSection("prescription-history-wrapper-id")
                  }
                  value="prescription-history-wrapper-id"
                />
                <Tab
                  icon={
                    <TbActivityHeartbeat className="icons-color" size={20} />
                  }
                  iconPosition="start"
                  label={<span className={`tabs_text`}>Vitals</span>}
                  onClick={() => scrollToSection("appleHealth-wrapper")}
                  value="appleHealth-wrapper"
                /> */}
            {/* <Tab
                  icon={<LiaHistorySolid className="icons-color" size={20} />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>RX History</span>}
                  onClick={() => scrollToSection("summary-details-wrapper")}
                /> */}
            {/* <Tab
                  icon={<SlGraph className="icons-color" size={20} />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>LifeTime Value</span>}
                  onClick={() => scrollToSection("lifetimeValue-wrapper")}
                  value="lifetimeValue-wrapper"
                /> */}
            {/* <Tab
                  icon={<CiHeart className="icons-color" size={20} />}
                  iconPosition="start"
                  label={<span className={`tabs_text`}>Summary</span>}
                /> */}
            {/* <Tab
                style={theme}
                icon={servicesIcon}
                iconPosition="start"
                label={
                  <span
                    className={`tabs_text notification-serv`}

                    // className={`tabs_text ${
                    //   value === 2 ? "active_tab" : ""
                    // } notification-serv`}
                  >
                    Services
                    {getServicesCount > 0 ? (
                      <div
                        className="notification-count"
                        style={{
                          background: darkMode === false ? "#111" : "grey",
                        }}
                      >
                        <p>{getServicesCount > 0 ? getServicesCount : 0}</p>
                      </div>
                    ) : (
                      ""
                    )}
                  </span>
                }
              /> */}

            {/* <div onClick={handleSearchIconClick} className="searchIc">
                <LiaSearchSolid size={20} className="icons-color" />
                <p>Search</p>
              </div> */}
            {/* </Tabs> */}

            {/* <div className="consultationDropdownContainer">
                <Dropdown
                  value={selectedConsultation}
                  onChange={handleConsultationChange}
                  options={consultationOptions}
                  optionLabel="label"
                  placeholder="Add Consultation"
                  className="dropdown"
                  panelClassName="invite-dropdown-panel"
                />
              </div> */}
            {/* </div> */}
            <div className="overview_mapbox">
              <Map
                initialViewState={viewport}
                scrollZoom={true}
                mapStyle={
                  darkMode
                    ? "mapbox://styles/mapbox/dark-v11"
                    : "mapbox://styles/mapbox/light-v11"
                }
                style={{
                  width: "100vw",
                  height: "40vh",
                }}
                mapboxAccessToken={import.meta.env.VITE_MAPBOX_TOKEN}
                attributionControl={false}
              >
                <Marker longitude={-3.2765753} latitude={54.7023545}>
                  <div className="patient-marker">
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 32 32"
                      fill="none"
                      stroke="#000"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_1469_20100)">
                        <rect
                          width="17"
                          height="17"
                          rx="8.5"
                          transform="matrix(-1 0 0 1 21 0)"
                          fill="white"
                        />
                        <rect
                          x="11"
                          y="7"
                          width="3"
                          height="3"
                          rx="1.5"
                          fill="black"
                        />
                        <rect
                          x="-0.5"
                          y="0.5"
                          width="16"
                          height="16"
                          rx="8"
                          transform="matrix(-1 0 0 1 20 0)"
                          stroke="black"
                          stroke-opacity="0.5"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1469_20100"
                          x="0"
                          y="0"
                          width="25"
                          height="25"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1469_20100"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1469_20100"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                </Marker>
              </Map>
            </div>
            <div
              className={`pharmacy-details-area patient-dashboard-details-area ${
                darkMode === false ? "" : "map-blur-black"
              }`}
            >
              <PatientDashboardPage
                onSectionChange={setActiveTab}
                onDarkModeChange={darkMode}
              />
              {/* {renderTabContent()} */}
            </div>
          </div>

          {isSearchIconClicked && (
            <div className="patientSearchModal">
              <PatientSearch
                show={isSearchIconClicked}
                setShow={isSearchIconClicked}
                handlePatientIconClick={handlePatientIconClick}
                handleCrossIconClick={handleCrossIconClick}
                onDarkModeChange={darkMode}
                pharmacyAvgVal={pharmacyAvgVal}
                selectedPatientName={selectedPatientName}
                selectedPatientAddress={selectedPatientAddress}
                navigateFromDashboard={navigateFromDashboard}
                pharmacyId={pharmacyId}
              />
            </div>
          )}
        </div>
      </div>
      <Dialog
        header="Confirmation"
        visible={showDialog}
        onHide={() => {
          setShowDialog(false);
          setSelectedConsultation(null);
        }}
        className={
          darkMode ? "custom-confirm-dialog-dm" : "custom-confirm-dialog"
        }
        footer={
          <>
            <CustomButton label="Yes" action={confirmConsultation} />
            <CustomButton label="No" action={cancelConsultation} />
          </>
        }
      >
        <div className="confirmation-dialog-content">
          <p>
            You have selected <strong>{selectedConsultation}</strong>
          </p>
          <p>Do you wish to continue?</p>
        </div>
      </Dialog>
      {/* {showPatientDetailsEditModal && <PatientDetailsEditModal />} */}
      {showPatientDetailsEditModal && (
        <AddPatientPopUp
          open={showPatientDetailsEditModal}
          onOpenChange={setCurrentShowPatientDetailsEditModal}
          onSave={(patient) => {}}
          isDarkMode={darkMode}
          editMode={selectedPatientDetails} // 👈 prefill happens here
        />
      )}
    </>
  );
};

export default PatientDashboard;
